/* eslint-disable */
/*
 * Please review the i18n documentation located in users/src/plugins/i18n/es.js
 */
import * as es from './es.js';

export default {
    ...es.default
};
